import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private themeSubject = new BehaviorSubject<'aura-then' | 'noir'>('noir');
  public theme$ = this.themeSubject.asObservable();
  
  constructor() {
    this.initTheme();
  }
  
  private loadPrimeNGTheme(theme: 'aura-then' | 'noir') {
    const linkId = 'primeng-theme-css';
    let linkElement = document.getElementById(linkId) as HTMLLinkElement;
    
    if (!linkElement) {
      linkElement = document.createElement('link');
      linkElement.id = linkId;
      linkElement.rel = 'stylesheet';
      document.head.appendChild(linkElement);
    }
    
    // Use CDN links for themes to avoid bundling issues
    const themeName = theme === 'aura-then' ? 'aura-then-light' : 'noir-dark';
    linkElement.href = `https://cdn.jsdelivr.net/npm/primeng@19.0.9/resources/themes/${themeName}/theme.css`;
    // linkElement.href = `assets/themes/${themeName}/theme.css`;

    
    // Also load core PrimeNG CSS if not already loaded
    if (!document.getElementById('primeng-core-css')) {
      const coreLink = document.createElement('link');
      coreLink.id = 'primeng-core-css';
      coreLink.rel = 'stylesheet';
      coreLink.href = 'https://cdn.jsdelivr.net/npm/primeng@19.0.9/resources/primeng.min.css';
      // coreLink.href = 'assets/primeng/primeng.min.css';
      document.head.appendChild(coreLink);
    }
  }
  
  setTheme(theme: 'aura-then' | 'noir') {
    // Apply theme class to body
    document.body.classList.remove('aura-then-theme', 'noir-theme');
    document.body.classList.add(`${theme}-theme`);
    
    // Load PrimeNG theme stylesheet
    this.loadPrimeNGTheme(theme);
    
    this.themeSubject.next(theme);
    localStorage.setItem('theme', theme);
    
  }
  
  toggleTheme() {
    const currentTheme = this.themeSubject.value;
    const newTheme = currentTheme === 'aura-then' ? 'noir' : 'aura-then';
    this.setTheme(newTheme);
  }
  
  initTheme() {
    const savedTheme = localStorage.getItem('theme') as 'aura-then' | 'noir' | null;
    this.setTheme(savedTheme || 'aura-then'); // Default to light theme
  }
} 